import { co2 } from './common';

export default {
  'consumption.co2': `Emisie ${co2} kombinované`,
  'consumption.energy': 'Kombinovaná spotreba elektrickej energie',
  'consumption.fuel': 'Spotreba paliva kombinovaná',
  'footnotes.local': '',
  'footnotes.wltp': `Uvedené hodnoty boli zistené podľa predpísaného spôsobu merania. Ide o „hodnoty ${co2} podľa skúšobného postupu WLTP“ v zmysle čl. 2 č. 3 vykonávacieho nariadenia (EÚ) 2017/1153. Hodnoty spotreby paliva boli vypočítané na základe týchto hodnôt. Spotreba elektrického prúdu bola zistená na základe nariadenia 683/2008/ES. Údaje sa nevzťahujú na konkrétne vozidlo a nie sú súčasťou ponuky. Slúžia len na porovnanie rôznych typov vozidiel. Hodnoty sa líšia v závislosti od zvolených prvkov mimoriadnej výbavy.`,
  'footnotes.nedc': `Uvedené hodnoty boli zistené podľa predpísaného spôsobu merania. Ide o „hodnoty ${co2} podľa NEDC“ v zmysle čl. 2, bodu 1 vykonávacieho nariadenia (EÚ) 2017/1153. Údaje sa nevzťahujú na konkrétne vozidlo a nie sú súčasťou ponuky, ale slúžia len na porovnanie rôznych typov vozidiel. Hodnoty sa líšia v závislosti od zvolených prvkov mimoriadnej výbavy.`,
  'footnotes.emissions.appendix': `Pre viac informácií ohľadom oficiálnych hodnôt spotrieb a emisií ${co2} osobných vozidiel vás prosíme aby ste kontaktovali vášho autorizovaného partnera Mercedes-Benz.`,
  'search.input.label': 'Vami vyhľadávaný pojem / Online kód konfigurátora',
  'search.result.buy-online': '',
  'search.results.count': '{count} výsledkov vyhľadávania',
  'search.results':
    'Nenašli sme žiaden výsledok. | {count} výsledok vyhľadávania | {count} výsledky vyhľadávania | {count} výsledkov vyhľadávania',
  'search.results.backup': 'Nenašli sme žiaden presný výsledok. Pozrite si súvisiace stránky:',
  'search.results.none.summary':
    'Pre vami vyhľadávaný pojem sme nenašli žiaden výsledok. Vyhľadávanie, prosím, zopakujte s iným pojmom.',
  'search.show-more': 'Zobraziť viac',
  'search.unavailable': 'Vyhľadávanie momentálne nie je k dispozícii.',
  'search.result.new': 'Novinka',

  'input.placeholder': 'Vami vyhľadávaný pojem / Online kód konfigurátora',

  'suggestions.all_search_results': 'Všetky výsledky vyhľadávania',
  'suggestions.all_search_results_for': 'Zobraziť všetky výsledky pre',
  'suggestions.in': 'v',

  all: 'Všetky',
  UCOS: 'Jazdené vozidlá | Onlinový obchod',
  PASSENGER_CARS: 'Osobné vozidlá',
  VANS: 'Transportéry',
  NCOS: 'Nové vozidlá | Onlinový obchod',
  VIDEO: 'Videá',
  DEALER_LOCATOR: 'Vyhľadávanie obchodníka',
  CONFIGURATOR: 'Konfigurátor modelov',
  TEST_DRIVE: 'Predvádzacia jazda',
  VEHICLE_SEARCH: 'Vyhľadávanie vozidiel',
  COLLECT: 'Kolekcia a príslušenstvo',
  CONNECT: 'Obchod Mercedes me',
  ACCESSORIES: 'Autopríslušenstvo',

  'search.result.consumption': 'Spotreba',
  'watch.video': 'Pozrite si video',
  'input.recently': 'Nedávno vyhľadávané',
  'input.help.title': 'Čo by ste mali hľadať?',
  'input.help.text':
    'Vyhľadávajte podľa typov vozidiel, modelov, kódov konfigurácií alebo vyhľadávajte príslušenstvo, ostatné produkty a informácie',

  'search.result.grid': 'Mriežka',
  'search.result.list': 'Zoznam',

  // No results
  'support.check': 'Skontrolujte, prosím, či nedošlo k preklepu alebo to skúste znova s iným výrazom.',
  'support.no.results': 'Pre tento hľadaný výraz nie sú k dispozícii žiadne výsledky vyhľadávania.',
  'support.no.results.term': 'Nenašli sa žiadne výsledky',
  'support.chat': 'Neviete nájsť to, čo hľadáte? Využite, prosím, našu',
  'support.chat.with.us': 'online chatovú podporu.',

  'search.results.offer': 'Populárne ponuky pre: "{query}":',
};
